// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__pJYJ7","shimmer":"styles_shimmer__wWqg9"};